module.exports = __webpack_public_path__ + "media/images/completed-21664bc5cd03d631020afc15f9b93168.svg";